import EventService from '../../../helpers/classes/EventService';
import LanguageService from '../../../helpers/classes/LanguageService';
import TemplateService from '../../../helpers/classes/TemplateService';
import { JourneyContainer } from '../../classes/JourneyContainer';
import JourneyManager from '../../classes/JourneyManager';
import { JourneyEvent } from '../../enums/JourneyEvent';
import { Templates } from '../../enums/Templates';
import { TranslationKey } from '../../enums/Translation';
import { IDocumentImage } from '../../interfaces/DocumentImage';
import { JourneySelectStep } from '../../renderers/step/journeySelect';

export class ResultsStep {
	public static render(this: JourneyContainer) {
		return (
			TemplateService.renderToContainer(this._container, Templates.Result)
				.then(() => JourneyManager.getResults(this._journey!.id))
				.then((results) => {
					const data = {
						result: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_${results.highLevelResult}` as TranslationKey),
						resultMessage: results.highLevelResult == "Expired" ? LanguageService.getTranslation(TranslationKey.RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE) : null,
						referenceId: results.referenceNumber,
						journeyId: (results as any).JourneyId,
						resultDetails: (results as any).HighLevelResultDetails.filter((x: string) => !x.startsWith('DOCUMENTBACKSIDECHECK') && !x.startsWith('DATACHECKS')).map((result: string) => {
							const [name, value] = result.split(':');

							return {
								_name: name.toLowerCase(),
								name: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_DETAIL_${name}` as TranslationKey),
								value: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_DETAIL_VALUE_${value}` as TranslationKey),
							};
						}),
						dataLookBackCheckDetails: ResultsStep.getLookBackCheckDetails((results as any).JourneySteps),
						trustScoreDetails: ResultsStep.getTrustScoreDetails((results as any).additionalData),
						GBGScoreDetails: ResultsStep.getGBGScoreDetails((results as any).additionalData),
						dataChecksDetails: ResultsStep.getDataCheckDetails((results as any).JourneySteps.find((step: any) => step.Type === "ADDITIONALDATA")),
						documents: results.processedDocuments.map((document) => ({


							_type: document.documentType.toLowerCase(),
							_result: document.highLevelResult.toLowerCase(),
							type: LanguageService.getTranslation(`SUPPORTED_DOCUMENT_${document.documentType}` as TranslationKey),
							result: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_${document.highLevelResult}` as TranslationKey),
							extractedFields: document.extractedFields.map((field) => ({
								_name: field.name.toLowerCase(),
								name: LanguageService.getTranslation(`EXTRACTED_FIELDS_${field.name}` as TranslationKey),
								value: field.value,
							})),
							images: document.documentImages.filter((x: IDocumentImage) => x.role.includes('WhiteImage')).map((image) => ({
								_type: image.type,
								_role: image.role,
								_url: image.url
							}))
						}))
					};

					return TemplateService.renderToContainer(this._container, Templates.Result, data);
				})
				.catch((ex) => {
					return TemplateService.renderToContainer(this._container, Templates.Result, {
						result: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_${this._journey!.result}` as TranslationKey),
						journeyId: this._journey!.id
					});
				})
		)
			.then(() => TemplateService.getElements(this._container, {
				logout: '[data-jcs-element="result__logout"]',
				start: '[data-jcs-element="result__journey__restart"]',
			}))
			.then(({ start, logout }) => {
				if (start) {
					start.addEventListener('click', () =>
						this.clearJourney()
							// .then(() => this.getJourney())
							// .then(() => this.evaluate())
							.then(() => JourneySelectStep.render.call(this))
					);
				}

				if (logout) {
					logout.addEventListener('click', () =>
						this.clearJourney()
							.then(() => this._journeyDefinitionId = '')
							.then(() => JourneyManager.logout())
					);
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_STEP, { step: Templates.Result }));

	}

	public static getLookBackCheckDetails(steps: any) {
		const step = steps.find((step: any) => step.Type === "ADDITIONALDATA");

		if (step) {
			const lookBackCheck = step.ValidationChecks.find((check: string) => check.startsWith("LOOKBACKCHECK"));

			if (lookBackCheck) {
				const [name, value] = lookBackCheck.split(':');

				return {
					_name: "lookbackcheck",
					name: LanguageService.getTranslation(`ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK` as TranslationKey),
					value: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_DETAIL_VALUE_${value}` as TranslationKey),
				}
			}
		}

		return {
			_name: "lookbackcheck",
			name: LanguageService.getTranslation(`ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK` as TranslationKey),
			value: LanguageService.getTranslation(`ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA` as TranslationKey)
		}
	}

	public static getTrustScoreDetails(additionalData: any) {
		const data = additionalData.find((additionalData: any) => additionalData.name === "SipTrustScore");

		if (data) {
			const trustScoreValue = data.value;

			if (trustScoreValue) {
				return {
					_name: "trustScore",
					name: LanguageService.getTranslation(`GBG_TRUST_SCORE` as TranslationKey),
					value: trustScoreValue,
				}
			}
		}
	}

	public static getGBGScoreDetails(additionalData: any) {
		const data = additionalData.find((additionalData: any) => additionalData.name === "GBGScore");

		if (data) {
			const GBGScoreValue = data.value;

			if (GBGScoreValue) {
				return {
					_name: "GBGScore",
					name: LanguageService.getTranslation(`GBG_SCORE` as TranslationKey),
					value: GBGScoreValue,
				}
			}
		}
	}

	public static getDataCheckDetails(step: any) {
		if (step) {
			const dataCheck = step.ValidationChecks.find((check: string) => check.startsWith("DATACHECKS"));

			if (dataCheck) {
				const [name, value] = dataCheck.split(':');

				return {
					_name: name.toLowerCase(),
					name: LanguageService.getTranslation(`ADDITIONAL_CHECKS_DETAIL_DATACHECKS` as TranslationKey),
					value: LanguageService.getTranslation(`RESULTS_HIGH_LEVEL_DETAIL_VALUE_${value}` as TranslationKey),
				}
			}
		}
	}

}
